import React from "react";

import "./index.css";

import SetupChargesTableContainer from "./SetupChargesTableContainer";
import { SetupChargesContextProvider } from "../../../../contexts/setup-charges.context";

function SetupCharges(props) {
  return (
    <div className="deco-container">
      <SetupChargesTableContainer />
    </div>
  );
}

export default SetupCharges;
